module.exports = __webpack_public_path__ + "prod/20260406142510/img/service.edbff227.png";